import { render, staticRenderFns } from "./PhoneWebrtcVideo.vue?vue&type=template&id=7b729306&scoped=true&lang=pug"
import script from "./PhoneWebrtcVideo.vue?vue&type=script&lang=js"
export * from "./PhoneWebrtcVideo.vue?vue&type=script&lang=js"
import style0 from "./PhoneWebrtcVideo.vue?vue&type=style&index=0&id=7b729306&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b729306",
  null
  
)

export default component.exports